import { render, staticRenderFns } from "./monthly-transaction-chart-based-psp.vue?vue&type=template&id=00ba0d95&scoped=true"
import script from "./monthly-transaction-chart-based-psp.vue?vue&type=script&lang=js"
export * from "./monthly-transaction-chart-based-psp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba0d95",
  null
  
)

export default component.exports